import useProject from '@hooks/useProject';

function useInquiryInfo() {
  const project = useProject();
  const inquiryInfo = project?.inquiryInfo;
  const inquiryEnabled = project?.features.inquiryEnabled;
  return {
    ...inquiryInfo,
    inquiryEnabled,
  };
}

export default useInquiryInfo;
